// eslint-disable-next-line no-restricted-imports
import { LegalClientHeadFragment } from 'api/generated/graphql';
import { LegalClientHeadEntity } from 'api/types/entity';
import { lodash } from 'helpers';

import {
  parseCountryEntity,
  parseKyc,
  parseOnboardingProcessEntity,
  parsePepConnectionEntity,
  parseResidentialAddressEntity,
  parseTaxResidenceEntity,
} from '../../../helpers';
import { parseHeadPositionEntity } from '../../helpers/parseHeadPositionEntity';
import { parseLegalClientBodyEntity } from '../../helpers/parseLegalClientBodyEntity';
import { parseLegalClientOnboardingStatus } from '../../helpers/parseLegalClientOnboardingStatus';

export const parseLegalClientHeadEntity = (
  data: LegalClientHeadFragment
): LegalClientHeadEntity => ({
  id: data.id,
  createdAt: new Date(data.createdAt),
  firstName: data.firstName,
  lastName: data.lastName,
  email: data.email,
  middleName: data.middleName || undefined,
  dateOfBirth: new Date(data.dateOfBirth),
  isFirstHead: data.isFirstHead ?? undefined,
  legalClientId: data.legalClientId || undefined,
  onboarding: data.onboarding
    ? {
        process: parseOnboardingProcessEntity(data.onboarding?.process),
      }
    : undefined,
  legalClientBodies: data.legalClientBodies
    ? parseLegalClientBodyEntity(lodash.compact(data.legalClientBodies))
    : undefined,

  legalClientOnboardingStatus: data.legalClientOnboardingStatus
    ? parseLegalClientOnboardingStatus(data.legalClientOnboardingStatus)
    : undefined,

  citizenships: data.citizenships
    ? lodash.compact(data.citizenships).map(parseCountryEntity)
    : undefined,
  taxResidences: data.taxResidences
    ? lodash.compact(data.taxResidences).map(parseTaxResidenceEntity)
    : undefined,
  placeOfBirth: data.placeOfBirth,
  registrationAddress: data.registrationAddress,
  residentialAddress: parseResidentialAddressEntity(data.residentialAddress),
  pepConnection: parsePepConnectionEntity(data),
  position: data.positionInCompany
    ? parseHeadPositionEntity(data.positionInCompany)
    : undefined,

  kyc: parseKyc(data.kyc),
  hasLegalClientBody: data.hasLegalClientBody ?? undefined,
});
